import { styled } from '@mui/material/styles';
import { Box, Container, LinearProgress } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const HeaderSection = styled('div')({
  backgroundColor: '#fff',
  borderRadius: '8px',
  marginBottom: '24px',
});

export const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 12,
  backgroundColor: '#F7E1D7',
  borderRadius: '6px',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#EDAFB8',
    borderRadius: '6px',
  }
}));

export const StickyFooter = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: theme.spacing(2),
  zIndex: 100,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: '#D4E6D4',
  color: '#333A3B',
  padding: theme.spacing(3),
  marginTop: theme.spacing(2),
  boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
}));

export const JuzGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 20px;
  }
`; 